const messages = {
  title: "Obchod",
  description: "Vítejte v obchodě s odměnami. Zde můžete vyměnit své body Bridgestone Plus <br/> za odměny z různých kategorií. Nabídka produktů <br/> je pravidelně aktualizována. Doufáme, že se vám bude procházení líbit.",
  sort: {
    asc: "Seřadit podle: Nejnižší cena",
    desc: "Seřadit podle: Nejvyšší cena",
  },
  productSearchBox: {
    from: "body od",
    to: "body do",
  },
  noProducts: "Vyhledávací kritéria nevrátila žádné výsledky",
  quantity: "Množství",
  search: "Hledat",
  perPage: "Položek na stránku",
  timeUnavailable: "Momentálně není k dispozici",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Body / jednotka",
    pointsSum: "Součet bodů",
  },
  action: "Akce",
  pointsTotal: "Celkem",
  cartRemainPoints: "Zbývající body v košíku",
  shoppingCart: "Nákupní košík",
  emptyCart: "Nákupní košík je prázdný.",
  attributes: "Atributy",
  selectAddressP: "Vyberte prosím doručovací adresu",
  orderDelivery: "Doručovací adresa",
  selectedProducts: "Vybrané produkty",
  orderSummary: "Přehled objednávky",
  contactPerson: "Kontaktní osoba",
  selectedAddress: "Vybraná adresa",
  order: {
    success: "Děkujeme! Vaše objednávka byla úspěšná. Za několik minut obdržíte potvrzení objednávky ve své schránce.",
    description: "Zde najdete přehled svých objednávek z obchodu s odměnami.",
    info: "Zde najdete přehled svých objednávek z obchodu s odměnami.",
    date: "Datum objednávky",
    number: "Č. objednávky",
    status: {
      created: "Vytvořeno",
      confirm_order: "Potvrdit objednávku",
      ready_for_shipment: "Připraveno k odeslání",
      rejected: "Zamítnuto",
      processed: "Zpracováno",
      shipped: "Odesláno",
      returned: "Vráceno",
      finished: "Dokončeno",
    },
    anyOrder: "Žádné objednávky",
    products: "Produkty",
    quantity_short: "ks",
    itemRemoved: "nelze doručit",
  },
  orders: "Objednávky",
  notEnoughPoints: "Nemáte dostatek bodů.",
  statusText: "Stav",
  outOfStock: "Momentálně není skladem",
  productUnavailable: "Tento produkt již není k dispozici.",
  deletedProductsTitle: "Produkty již nejsou k dispozici",
  deletedProductsMessage: "Následující produkty již nejsou k dispozici. Odstraňte je z košíku, abyste mohli pokračovat.",
  removeSelected: "Odebrat vybrané",
  clearCart: "Vyprázdnit košík",
  removeSelectedConfirm: "Odebrat vybrané produkty z košíku?",
  clearCartConfirm: "Odebrat všechny produkty z košíku?",
  incompleteAddress: {
    firstName: "Přidejte k doručovací adrese křestní jméno",
    lastName: "Přidejte k doručovací adrese příjmení",
    company: "Přidejte k doručovací adrese název společnosti",
    street: "Přidejte k doručovací adrese ulici a číslo popisné",
    postalCode: "Přidejte k doručovací adrese PSČ",
    city: "Přidejte k doručovací adrese město",
    country: "Přidejte k doručovací adrese zemi",
    phone: "Přidejte k doručovací adrese telefonní číslo",
  },
  placeOrder: "Závazná objednávka",
  toOrderDelivery: "Pokračovat na doručovací adresu",
  toOrderSummary: "Přejít na přehled objednávky",
  productImg: "Obrázek produktu",
  selectAddressBtn: "Vybrat adresu",
  perPgae: "Položek na stránku",
  categories: {
    advertising: {
      title: "Reklamní materiály",
      desc: "Zúčastněte se přímo zde na platformě a získejte <br/> 40 extra bodů pro odměnový klub.",
    },
    rewards: {
      title: "Exkluzivní odměny",
      desc: "Objevte bonusovou nabídku v našem školicím centru nebo u vás na místě.",
    },
    tools: {
      title: "Nářadí pro dílnu",
      desc: "Využijte body na školení třetích stran <br/> a snižte své náklady.",
    },
    trainings: {
      title: "Školení a kurzy",
      desc: "Objevte bonusovou nabídku v našem školicím centru nebo u vás na místě.",
    },
    salesroom: {
      title: "Prodejna",
      desc: "Upravte prodejnu a nabídněte zákazníkům příjemný pobyt.",
    },
    hunter: {
      title: "Hunter",
      desc: "Vyměňte body za atraktivní vybavení dílny od Hunter.",
    },
  },
  bestSold: "Nejprodávanější",
  seasonal: "Sezónní",
  affordable: "Skoro hotovo",
  forPoints: "za {points} bodů",
  reachedPoints: "Požadovaný počet bodů dosažen",
  remainingPoints: "Chybí {points} bodů",
  favoriteProducts: {
    description: "Zde najdete uložené produkty.",
  },
  categoryPageDescriptionFallback: "Materiál do dílny nebo jiné kvalitní produkty s logem Bridgestone pro vaši firmu",
  variant: "Volitelné varianty",
};
export default {
  messages,
};
